module.exports = __webpack_public_path__ + "img/teller_refloat.b66ca0a1.png";